import { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { InfoModal, NoResults } from 'basic-components';
import { DataScienceQuery } from 'dashboard-services/api/dataScience';
import Query from 'dashboard-services/api/Query';

import { inspectorActions } from 'actions/modules/tools';
import getApiConfig from 'api/ApiConfig';
import { sendEvent } from 'services/GAService';

import ActionsRow from './ActionsRow';

import { useQuery } from '@tanstack/react-query';
import { When } from 'react-if';

import classNames from 'classnames';
import './Inspector.scss';

const parseResponse = response => response?.pipelineAndTasks || []
const useFileUsage = ({ getQueryBuilder, name, groupName, fileType }) =>
  useQuery({
    ...DataScienceQuery.QUERIES.getFileUsage(
      getQueryBuilder,
      {
        name,
        groupName,
        fileType
      }
    ),
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    select: parseResponse
  })
const EMPTY_ARRAY = [];
const Inspector = () => {
  const dispatch = useDispatch(),
        { groupName, name, title, type } = useSelector(state => state.toolsState.inspectorState),
        clearInspector = useCallback(() => {
          dispatch(inspectorActions.changeValue(undefined, 'groupName'))
          dispatch(inspectorActions.changeValue(undefined, 'name'))
          dispatch(inspectorActions.changeValue(undefined, 'type'))
          dispatch(inspectorActions.changeValue(false, 'open'))
        }, [dispatch]),
        getQueryBuilder = useCallback(() => new Query.Builder(dispatch(getApiConfig())).withShouldTimeOut(false), [dispatch]),
        { data: items = EMPTY_ARRAY, isPending } = useFileUsage({ getQueryBuilder, name, groupName, fileType: type }),
        close = useCallback(() => dispatch(inspectorActions.changeValue(false, 'open')), [dispatch])

  useEffect(() => () => {
    clearInspector()
  }, [clearInspector])

  useEffect(() => {
    const event = {
      category: "view_item",
      action: "usage_inspector",
      label: "tool",
    };
    dispatch(sendEvent(event))
  }, [dispatch])

  return (
    <InfoModal 
        className={classNames(
          "ng-inspector",
          { "ng-inspector--no-results": items?.length === 0 && !isPending }
        )}
        onClose={close}
        open
        optionalText={`${groupName}: ${name}`}
        size="large"
        sizeWidth="large"
        title={`${title} used in ${items.length} pipeline${items?.length === 1 ? "" : "s"}`}
    >
      <div className="ng-inspector__list-headers">
        <div className="ng-inspector__list-headers__item">
          Name
        </div>
        <div className="ng-inspector__list-headers__item">
          Version
        </div>
        <div className="ng-inspector__list-headers__item">
          Group
        </div>
        <div className="ng-inspector__list-headers__item">
          Tasks
        </div>
      </div>
      <div className="ng-inspector__list-content">
        <When condition={items.length !== 0 && !isPending}>
          {() => (
            <ActionsRow items={items}/>
          )}
        </When>
      </div>
      <When condition={items.length === 0 && !isPending}>
        {() => (
          <NoResults
              isFullModal
              title={`${title} has not been used in any pipeline.`}
          />
        )}
      </When>
    </InfoModal>
  )
}

export default memo(Inspector);